import { SpacingSmallTopBottom, LocalizedSectionTitle } from '@mews-commander/ui';
import { DataTestId } from '@mews-commander/enums';

interface Props {
    textKey: Mews.TextKey;
    testId?: DataTestId;
}

const DashboardTitle: React.FC<Props> = ({ textKey, testId }) => (
    <SpacingSmallTopBottom>
        <LocalizedSectionTitle testId={testId} textKey={textKey} />
    </SpacingSmallTopBottom>
);

export default DashboardTitle;
